<template>
  <div class="name bl">
    <van-nav-bar :title="$t('changePhone')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" @click="back()"/>
      </template>
	  <template #right>
	    <span class="nav-right" style="color:#735db2" @click="save()">{{$t('save')}}</span>
	  </template>
    </van-nav-bar>
	<van-cell-group>
	  <van-field  readonly :label="$t('existingPhone')" :value="userInfo.phone" />
	  <van-field v-model="phone"  :label="$t('newPhone')"  />
	</van-cell-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone:"",
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    save(){
      this.$http({
        method: 'post',
        data:{phone:this.phone},
        url: 'user_set_sex'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
		  this.phone = '';
          this.$toast(res.msg);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.radio = res.data.sex;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
.van-nav-bar {
	position: relative;
    z-index: 999;
	height:3rem ;
	color: #735db2;
	line-height: 3rem;
    background: none
}
.van-nav-bar__content{
	height:3rem;
}
.name {
    width: 100%;
    height: 100%;
    background: #f0f0f0;
    background: linear-gradient(180deg,#fff,#fefae9)
}

.name .van-hairline--bottom:after {
    border-bottom-width: 0
}

.name .van-cell {
    padding: 16px 20px;
    background: none;
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 0.5rem 0.6rem;
    overflow: hidden;
    color: #323233;
    font-size: 1rem;
    line-height: 2rem;
}
.name .van-cell .van-cell__title {
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.name .van-cell .van-cell__title img {
    width: 20px;
    margin-right: 6px
}

.name .van-cell .van-cell__value {
    color: #735db2
}

.name .van-nav-bar {
    background: none
}

.name .van-nav-bar .van-icon,.name .van-nav-bar__title {
    color: #ffffff
}

.name>p {
    color: #dc2037;
    font-size: .8rem;
    padding: 1rem 0
}

@media (max-width: 430px) {
  .name {
    min-width: 0;
    min-height: 100svh;
    overflow-x: hidden;
  }

  .name .nav-bar {
    height: auto;
    min-height: 52px;
    padding-top: env(safe-area-inset-top);
  }

  .name ::v-deep .van-nav-bar__content {
    min-height: 52px;
  }

  .name ::v-deep .van-nav-bar__title {
    max-width: 48%;
    font-size: 16px;
    line-height: 1.25;
    white-space: normal;
  }

  .name ::v-deep .van-nav-bar__left,
  .name ::v-deep .van-nav-bar__right {
    padding: 0 12px;
  }

  .name .nav-right {
    display: block;
    max-width: 92px;
    overflow: hidden;
    font-size: 14px;
    line-height: 1.25;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .name ::v-deep .van-cell {
    min-width: 0;
    display: block;
    padding: 12px 16px;
    overflow: visible;
  }

  .name ::v-deep .van-field__label {
    width: 100%;
    margin: 0 0 4px;
    font-size: 15px;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .name ::v-deep .van-field__value,
  .name ::v-deep .van-field__body,
  .name ::v-deep .van-field__control {
    width: 100%;
    min-width: 0;
  }

  .name ::v-deep .van-field__control {
    min-height: 34px;
    font-size: 16px;
  }
}
</style>
